exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control.columns[data-v-b8e3a2ee] {\n  position: relative;\n}\n.control.columns .alert.alert-warning[data-v-b8e3a2ee] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n#droparea p.caution[data-v-b8e3a2ee] {\n  font-size: 12.5px;\n  line-height: 1.6;\n  color: #e48365;\n  text-align: left;\n  display: inline-block;\n  padding: 0;\n}", ""]);

// exports
